import React from 'react'
import NotItems from '@ui/notItems/NotItems'
import {Box, Button, Chip, IconButton, Tooltip, Typography} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {CameraVideoPlayer} from '@containers/video/videoStreams/cameraPlayer/CameraVideoPlayer'
import VideocamIcon from '@mui/icons-material/Videocam'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import {IDeviceVideoStream} from '@containers/video/videoStreams/types'
import sx from '@containers/video/videoStreams/cameraPlayer/sx'

export const DeviceCameraPlayerContent = ({
											  devices,
											  cameraSrc,
											  onChangeChangeSrc,
											  fullSize

										  }: {
	devices: IDeviceVideoStream[]
	cameraSrc: string | null
	onChangeChangeSrc: (cameraSrc: string | null) => void
	fullSize?:boolean
}) => {
	return (
		<Box sx={sx.root}>
			{!devices?.length && <NotItems/>}

			{cameraSrc && (
				<Box sx={sx.stage}>
					<Button
						size="small"
						variant="contained"
						startIcon={<ArrowBackIcon fontSize={'small'}/>}
						onClick={() => {
							onChangeChangeSrc(null)
						}}
						sx={sx.changeBtn}
					>
						Змінити
					</Button>
					<CameraVideoPlayer
						src={cameraSrc}
						sx={sx.video}
					/>
				</Box>
			)}

			{!cameraSrc && devices.length > 0 && (
				<Box sx={sx.list}>
					<Typography sx={sx.listTitle}>
						Оберіть камеру
					</Typography>
					{devices.map((device) => (
						<Box key={device.hostName} mb={1}>
							{device.hostName && <Typography variant="caption" sx={sx.host}>
								{device.hostName}
							</Typography>}
							{Object.entries(device.cameras).map(([name, streams]) => {
								const src = streams.hd ?? streams.sd
								return (
									<Box key={name} sx={sx.cameraRow}>
										<Button
											variant="outlined"
											startIcon={<VideocamIcon/>}
											disabled={!src}
											onClick={() => src && onChangeChangeSrc(src)}
											sx={sx.cameraBtn}
										>
											{name}
											<Chip
												label={streams.hd ? 'HD' : 'SD'}
												size="small"
												sx={sx.quality}
											/>
										</Button>

										<Tooltip title="Відкрити потік у новій вкладці">
											<span>
												<IconButton
													size="small"
													component="a"
													href={src || undefined}
													target="_blank"
													disabled={!src}
													sx={sx.link}
												>
													<OpenInNewIcon fontSize="small"/>
												</IconButton>
											</span>
										</Tooltip>
									</Box>
								)
							})}
						</Box>
					))}
				</Box>
			)}
		</Box>
	)
}
